"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevealType = exports.CharacterMotionType = void 0;
var CharacterMotionType;
(function (CharacterMotionType) {
    CharacterMotionType[CharacterMotionType["Normal"] = 0] = "Normal";
    CharacterMotionType[CharacterMotionType["Entering"] = 1] = "Entering";
    CharacterMotionType[CharacterMotionType["Exiting"] = 2] = "Exiting";
})(CharacterMotionType = exports.CharacterMotionType || (exports.CharacterMotionType = {}));
var RevealType;
(function (RevealType) {
    /**
     * User can choose while there's time left. Then auto reveals when time expires. No reveal button.
     */
    RevealType["CHOICE_AUTO"] = "ChoiceAutoReveal";
    /**
     * User can choose while there's time left. Then presses reveals when time expires. Show reveal button.
     */
    RevealType["CHOICE_CLICK"] = "ChoiceClickReveal";
    /**
     * User never chooses anything, all automatic. No choice button, no reveal button.
     */
    RevealType["AUTO"] = "AutomaticReveal";
    /**
     * User presses reveal to choose one at random. No choice button, show reveal button.
     */
    RevealType["CLICK"] = "RequiresClickReveal";
})(RevealType = exports.RevealType || (exports.RevealType = {}));
//# sourceMappingURL=types.js.map